module.exports = __webpack_public_path__ + "static/media/trudi.4b11c74c.jpg";